export const optichiller2CompGaugeConfig = [
  // Columna 1 — Succión C1 bien 
  {
    key: "presionSuccionComp1",
    title: "Pres. Succión Compresor 1",
    unit: "psi",
    ranges: [
      { min: 7, max: 9.99, color: "green" },
      { min: 4, max: 6.99, color: "yellow" },
      { min: 10, max: 13.99, color: "yellow" },
      { min: 0,  max: 3.99, color: "red" },
      { min: 14, max: 10000, color: "red" },
    ],
  },

    // Columna 2 — Succión C2
  {
    key: "presionSuccionComp2",
    title: "Pres. Succión Compresor 2",
    unit: "psi",
    ranges: [
      { min: 7, max: 9.99, color: "green" },
      { min: 4, max: 6.99, color: "yellow" },
      { min: 10, max: 13.99, color: "yellow" },
      { min: 0,  max: 3.99, color: "red" },
      { min: 14, max: 10000, color: "red" },
    ],
  },

  // Columna 3 — Proceso Entrada bien 
  {
    key: "tempProcesoEntrada",
    title: "Temp. Proceso Entrada",
    unit: "°C",
    ranges: [
      { min: 7,  max: 11.99, color: "green" },
      { min: 5,  max: 6.99,  color: "yellow" },
      { min: 12, max: 19.99, color: "yellow" },
      { min: 0,  max: 4.99,  color: "red" },
      { min: 20, max: 50000, color: "red" },
    ],
  },

   // Columna 4 — Proceso Salida
  {
    key: "tempProcesoSalida",
    title: "Temp. Proceso Salida",
    unit: "°C",
    ranges: [
      { min: 7,  max: 11.99, color: "green" },
      { min: 5,  max: 6.99,  color: "yellow" },
      { min: 12, max: 19.99, color: "yellow" },
      { min: 0,  max: 4.99,  color: "red" },
      { min: 20, max: 50000, color: "red" },
    ],
  },

  // Columna 5 — Torre Entrada
  {
    key: "tempTorreEntrada",
    title: "Temp. Torre Entrada",
    unit: "°C",
    ranges: [
      { min: 27, max: 30.99, color: "green" },
      { min: 25, max: 26.99, color: "yellow" },
      { min: 31, max: 34.99, color: "yellow" },
      { min: 0,  max: 24.99, color: "red" },
      { min: 35, max: 50000, color: "red" },
    ],
  },

  // Columna 6 — Torre Salida
  {
    key: "tempTorreSalida",
    title: "Temp. Torre Salida",
    unit: "°C",
    ranges: [
      { min: 30, max: 34.99, color: "green" },
      { min: 26, max: 29.99, color: "yellow" },
      { min: 35, max: 37.99, color: "yellow" },
      { min: 0,  max: 25.99, color: "red" },
      { min: 38, max: 500000, color: "red" },
    ],
  },

  // Columna 7 — Temp Descarga C1
  {
    key: "tempDescargaComp1",
    title: "Temp. Descarga Compresor 1",
    unit: "°C",
    ranges: [
      { min: 50, max: 69.99,  color: "green" },
      { min: 40, max: 49.99,  color: "yellow" },
      { min: 70.1, max: 90.99,  color: "yellow" },
      { min: 0,  max: 39.99,  color: "red" },
      { min: 91, max: 15000, color: "red" },
    ],
  },

  // Columna 8 — Temp Descarga C2
  {
    key: "tempDescargaComp2",
    title: "Temp. Descarga Compresor 2",
    unit: "°C",
    ranges: [
      { min: 50, max: 69.99,  color: "green" },
      { min: 40, max: 49.99,  color: "yellow" },
      { min: 70, max: 91,  color: "yellow" },
      { min: 0,  max: 39.99,  color: "red" },
      { min: 91.1, max: 15000, color: "red" },
    ],
  },

  // Columna 9 — Presión Descarga C1 bien 
  {
    key: "presionDescargaComp1",
    title: "Pres. Descarga Compresor 1",
    unit: "psi",
    ranges: [
      { min: 100, max: 119.99, color: "green" },
      { min: 89,  max: 99.99, color: "yellow" },
      { min: 120, max: 130.99, color: "yellow" },
      { min: 0,   max: 88.99,  color: "red" },
      { min: 131, max: 200000, color: "red" },
    ],
  },

  // Columna 10 — Presión Descarga C2
  {
    key: "presionDescargaComp2",
    title: "Pres. Descarga Compresor 2",
    unit: "psi",
    ranges: [
      { min: 100, max: 119.99, color: "green" },
      { min: 89,  max: 99.99, color: "yellow" },
      { min: 120, max: 130.99, color: "yellow" },
      { min: 0,   max: 88.99,  color: "red" },
      { min: 131, max: 200000, color: "red" },
    ],
  },
];
